import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectDestructuringEmpty from "/home/prasanta/Projects/get-mutual-transfer-website/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import React from "react";
import { Urls } from "../../../util/constant";
import { AButton } from "../../atoms/Button/Button";
import styles from "./LoginNotice.module.css";
export default function LoginNotice(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/_jsxs("div", {
    className: styles.search_result_login_barrier,
    children: [/*#__PURE__*/_jsx("h4", {
      children: "Please LogIn/Register to view all search results"
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      children: [/*#__PURE__*/_jsx(AButton, {
        label: "Login",
        simpleOutlined: true,
        href: Urls.LOGIN_URL
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(AButton, {
          label: "Register",
          href: Urls.REGISTER_URL
        })
      })]
    })]
  });
}